import React, { Component } from 'react';
import Form from 'react-jsonschema-form';

class SchemaForm extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleError = this.handleError.bind(this);
  }
  handleChange(e) {
    const { formData } = e;
    if (this.props.onChange) {
      this.props.onChange(formData);
    }
  }
  handleSubmit(e) {
    const { formData } = e;
    if (this.props.onSubmit) {
      this.props.onSubmit(formData);
    }
  }
  handleError(errors) {
    if (this.props.onError) {
      this.props.onError(errors);
    }
  }
  render() {
    return (
      <Form
        formData={this.props.formData}
        schema={this.props.schema}
        uiSchema={this.props.uiSchema}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onError={this.handleError}
      />
    );
  }
}

export default SchemaForm;



// WEBPACK FOOTER //
// ./src/SchemaForm.js